import { render, staticRenderFns } from "./collectMoney.vue?vue&type=template&id=b1c665da&scoped=true"
import script from "./collectMoney.vue?vue&type=script&lang=js"
export * from "./collectMoney.vue?vue&type=script&lang=js"
import style0 from "./collectMoney.vue?vue&type=style&index=0&id=b1c665da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c665da",
  null
  
)

export default component.exports